var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 9.5,
    stroke: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.5,
    y1: 8.5,
    x2: 28.5,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FD9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarOutline);
export default __webpack_public_path__ + "static/media/AvatarOutline.5cbaea1d7ef2667545f7fbdddfbbbd7f.svg";
export { ForwardRef as ReactComponent };